import axios from 'axios';

const baseDomain = '';
const baseURL = `${baseDomain}/wp-json`;

export default axios.create({
    baseURL
});